import IsIos from '@/mixins/is-ios.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import formValidator from '@/mixins/form-validator.js'
import sessionStore from '@/stores/session-store.js'
import toastStore from '@/stores/toast-store.js'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import logo from '@/assets/images/collectomate-logo.png'
import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'

export default {
  name: 'Session',
  mixins: [IsIos, CurrentUserResolver, formValidator, RedirectToLockersOrDeliveries],
  data: function () {
    return {
      errors: {},
      submitted: false,
      serviceProvider: window.serviceProvider,
      logo: logo,
      slug: 'collectomate',
      user: {
        email: null,
        password: null,
      },
      blocker: false,
    }
  },
  watch: {
    currentUser: {
      handler: function () {
        if (this.currentUser) this.redirectToLockersOrDeliveries()
      },
      deep: true,
    },
    user: {
      handler: function () {
        this.validateForm()
      },
      deep: true,
    },
  },
  mounted() {
    console.log('hello from Session component')
  },
  methods: {
    signIn: function (e) {
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true

        axios({
          method: 'post',
          url: 'auth/sign_in',
          data: {
            email: this.user.email,
            password: this.user.password,
          },
        })
          .then(response => {
            this.blocker = false
            if (response.status == 200) {
              sessionStore.commit('setData', response.data.token)
              sessionStore.commit('setUser', response.data.user)
              setTimeout(this.redirectToLockersOrDeliveries)
            }
            console.log('response signIn', response)
          })
          .catch(error => {
            this.blocker = false
            const errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
            console.error('error signIn', error.response)
          })
      }
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          email: {
            required,
          },
          password: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
